import type { PostalCodePillData } from "../../@types/mapviewxs";
import { getLocationChangeText } from "./helpers";
import { type MapViewModules, MessageName } from "./types";

function sendToParentWindow(eventName: string, data?: Record<string, any>) {
  window.parent.postMessage({ name: eventName, ...data }, "*");
}

export const sendModelToParentWindow = (model?: MapViewModules): void => {
  if (!model) {
    return;
  }

  const { title, subtitle, infotip, closeOverlay } = model.mapview;

  const { postalCode, distance, accessibilityText } = model.mapDataControls?.postalCodePillData || {};
  const locationChangeText = getLocationChangeText(postalCode, distance);

  sendToParentWindow(MessageName.MapView, {
    title,
    closeOverlay,
    ...(locationChangeText
      ? {
          locationChangeText,
          a11yLocationChangeText: accessibilityText,
        }
      : {
          subtitle,
          infotip,
        }),
  });
};

export const sendMapInitToParentWindow = (): void => {
  sendToParentWindow(MessageName.MapViewInitialized);
};

export const sendUpdatedLocationToParentWindow = (postalCodePillData?: PostalCodePillData): void => {
  if (!postalCodePillData) return;
  const { postalCode, distance, accessibilityText } = postalCodePillData;

  sendToParentWindow(MessageName.MapViewLocationChange, {
    locationChangeText: getLocationChangeText(postalCode, distance),
    a11yLocationChangeText: accessibilityText,
  });
};

/**
 * Registers an event listener for a specific message event.
 *
 * @param eventName - The name of the event message to listen for.
 * @param callback - The function to call when the event is received. The callback receives a `MessageEvent` object as its argument.
 */
export const onMessage = (eventName: string, callback: (event: MessageEvent) => void) => {
  window.addEventListener(
    "message",
    (event) => {
      if (typeof event.data === "object" && event.data.name === eventName) {
        console.log(`MapViewFE received message event "${eventName}"`, event);
        callback(event);
      }
    },
    false,
  );
};
